import CryptoJS from 'crypto-js';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import Loader from '../../../../../shared/components/loader'
import {Validator} from 'vee-validate';
import BookingService from './../../../../services/cargobooking.service';

export default {
  name: '',
  props:['selectedSellerDetails'],
  components: {
    BasicSelect,
    vueMultiSelect,
    Loader
  },
  data: function() {
    return {
      sellerid:"",
      sellergstno:"",
      sellername:"",
      selleraddress:"",
      pincode:"",
      zone:"",
      hub:"",
      telno:"",
      status:false,
      updateID:"",
      isLoading:false
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    if(this.selectedSellerDetails){
      this.sellerid = this.selectedSellerDetails.sellerid,
      this.selleraddress = this.selectedSellerDetails.address,
      this.sellergstno = this.selectedSellerDetails.gstin,
      this.sellername = this.selectedSellerDetails.sellername,
      this.pincode = this.selectedSellerDetails.pincode,
      this.zone = this.selectedSellerDetails.zone,
      this.hub = this.selectedSellerDetails.hub,
      this.status = this.selectedSellerDetails.status == 1 ? true :false,
      this.telno = this.selectedSellerDetails.telephone,
      this.updateID = this.selectedSellerDetails.id
    }
  },
  methods: {
    showSellerCragoDetails() {
      this.$emit("goBackToParent")
    },
    async createSellerDetails(){
      try {
        this.isLoading = true;
        var inputPayload = {};
        if(this.updateID){
          inputPayload.id = this.updateID;
        }
        inputPayload.sellerid = this.sellerid.trim(),
        inputPayload.sellergstno = this.sellergstno.trim(),
        inputPayload.sellername = this.sellername,
        inputPayload.selleraddress = this.selleraddress,
        inputPayload.pincode = this.pincode,
        inputPayload.zone = this.zone,
        inputPayload.hub = this.hub,
        inputPayload.telno = this.telno,
        inputPayload.status = this.status == true ? 1 : 0,
        inputPayload.lastmodifiedby = this.userName

        let result = await BookingService.saveSellerDetails(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, "", "success");
          this.$emit("goBackToParent");
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
      }
    },
    clearForm(){
      this.sellerid = "",
      this.sellergstno = "",
      this.sellername = "",
      this.selleraddress = "",
      this.pincode = "",
      this.zone = "",
      this.hub = "",
      this.telno = "",
      this.status = false
    },
    isIntegerOnlty: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.createSellerDetails(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/cargosellerdetails/createcargosellerdetails/createcargosellerdetails.component.js